import { useMutation, UseMutationResult } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface ICherryPickShiftsPayload {
  code: string;
  shift: string;
}

export const fetchCherryPickShifts = (payload: ICherryPickShiftsPayload) => {
  const newEndpoints = endpoints.shifts.cherryPick;
  return http().post(newEndpoints, payload);
};

export function useMutateCherryPickShifts(...options: any): UseMutationResult<any, Error, ICherryPickShiftsPayload> {
  return useMutation({
    mutationFn: fetchCherryPickShifts,
    onSuccess: undefined,
    ...options,
  });
}
